export const Create = {
  FilesToUpload: "filesToUpload" as const,
  Date: "date" as const,
  Text: "text" as const,
  AccountItems: "accountItems" as const,
  AccountBalances: "accountBalances" as const,
  TotalAmount: "totalAmount" as const,
  PostWithoutImage: "postWithoutImage" as const,
}

export const AccountItem = {
  AccountId: "accountId" as const,
  AccountName: "accountName" as const,
  Amount: "amount" as const,
  Dimensions: "dimensions" as const,
  BalanceBefore: "balanceBefore" as const,
  BalanceAfter: "balanceAfter" as const,
}

export const BalaceAccountItem = {
  AccountId: "accountId" as const,
  BalanceBefore: "balanceBefore" as const,
}

